<template>
	<div>
		<div class="form-row">
			<div v-if="RolUsuario!='Monitoreo'" class="col-lg-12">
                <label for="">Observaciones *</label>
                <textarea class="form-control" name="" id="" cols="30" rows="10" v-model="ReemplazoRefaccion.Observacion"></textarea>
                <Cvalidation v-if="this.errorvalidacion.Observacion" :Mensaje="errorvalidacion.Observacion[0]"></Cvalidation>
            </div>

			<div v-else class="col-lg-12">
                <label for="">Observaciones *</label>
                <textarea disabled class="form-control" name="" id="" cols="30" rows="10" v-model="ReemplazoRefaccion.Observacion"></textarea>
                <Cvalidation v-if="this.errorvalidacion.Observacion" :Mensaje="errorvalidacion.Observacion[0]"></Cvalidation>
            </div>
		</div>
	</div>
</template>

<script>
import Cbtnsave from '@/components/Cbtnsave.vue';
import Cvalidation from '@/components/Cvalidation.vue';
export default {
	props:["oEquipo","poBtnSave","RolUsuario"],
	components:{Cbtnsave, Cvalidation},
	data() {
		return {
			Modal:true,
			FormName:'reemplazorefaccion',
			ConfigLoad:{
                ShowLoader:true,
                ClassLoad:true
            },
			ReemplazoRefaccion:{
                IdReemplazoRefaccionEquipo:0,
                IdEquipo:0,
                Observacion:''
            },
			errorvalidacion:[]
		}
	},
	methods: {
		async Guardar(){
			this.poBtnSave.disableBtn=false;
            let formData=new FormData();
            formData.set('IdReemplazoRefaccionEquipo',this.ReemplazoRefaccion.IdReemplazoRefaccionEquipo);
            formData.set('Observacion',this.ReemplazoRefaccion.Observacion);
            formData.set('IdEquipo',this.oEquipo);
			await this.$http.post('reemplazorefaccionequipo/post',formData,{
                
            }).then((res)=>{
                this.poBtnSave.disableBtn=false;
                // this.poBtnSave.toast=1;
                this.$toast.success("Información guardada");
                $('#reemplazorefaccion').modal('hide');
                this.bus.$emit('Listar');
            }).catch((err)=>{
                this.errorvalidacion=err.response.data.message.errores;
                this.poBtnSave.disableBtn=false;
                // this.poBtnSave.toast=2;
                this.$toast.info("Complete los campos por favor");
            })
		},
		getOne(){
            this.$http.get('reemplazorefaccionequipo/recovery',
            {
                params:{IdReemplazoRefaccionEquipo:this.ReemplazoRefaccion.IdReemplazoRefaccionEquipo}
            }).then((res)=>{
                this.ReemplazoRefaccion.IdObservacion=res.data.data.reemplazorefaccion.IdReemplazoRefaccionEquipo;
                this.ReemplazoRefaccion.IdEquipo=res.data.data.reemplazorefaccion.IdEquipo;
                this.ReemplazoRefaccion.Observacion=res.data.data.reemplazorefaccion.Observacion;
            }).finally(()=>{
                this.ConfigLoad.ShowLoader=false;
            });
        },
		Limpiar(){
            this.ReemplazoRefaccion.IdReemplazoRefaccionEquipo=0;
            this.ReemplazoRefaccion.IdEquipo=0;
            this.ReemplazoRefaccion.Observacion='';
        }
	},
	created() {
		this.poBtnSave.toast=0;
		this.bus.$off('NuevaReemplazoRefaccion');
		this.bus.$on('NuevaReemplazoRefaccion',(data,Id)=>{
            this.ConfigLoad.ShowLoader=true;
            this.poBtnSave.disableBtn=false;
            this.bus.$off('Save_ReemplazoRefaccion');
            this.bus.$on('Save_ReemplazoRefaccion',()=>{
                this.Guardar();
            });
            this.Limpiar();
            if(Id>0){
                this.ReemplazoRefaccion.IdReemplazoRefaccionEquipo=Id;
                this.getOne();
                this.bus.$emit('Desbloqueo',false);
            }
            else{
                this.ConfigLoad.ShowLoader=false;
            }
        });
        if (this.ReemplazoRefaccion.IdReemplazoRefaccionEquipo!=0) {
            this.getOne();
        }
	},
}
</script>

<style>

</style>
